import { motion } from 'framer-motion'
import { PiArrowRight, PiCar, PiReceipt, PiPercent, PiCalendarCheck, PiGasPump, PiCurrencyEur, PiWarning, PiSparkle, PiTrendUp, PiClipboardText, PiRobot, PiShieldWarning, PiLinkBreak, PiEyeSlash, PiHandCoins } from 'react-icons/pi'
import { Link } from 'react-router-dom'

import HeaderBack from '@/components/dashboard/Header/HeaderBack'
import MotionText from '@/components/common/Motion/MotionText'
import MotionDiv from '@/components/common/Motion/MotionDiv'
import { usePageSetup } from '@/hooks/usePageSetup'

interface BlogArticle {
  slug: string
  title: string
  excerpt: string
  icon: React.ComponentType<{ className?: string }>
  readTime: string
  category: string
  publishDate: string
}

const articles: BlogArticle[] = [
  {
    slug: 'kas-yra-finhudas-apskaitos-programa-pavezejams',
    title: 'Finhudas: vienintelė programa, automatiškai importuojanti Bolt ataskaitas',
    excerpt: 'Kiek valandų šį mėnesį praleidote skaičiuodami mokesčius? Profesionalūs pavežėjai naudoja Finhudas.',
    icon: PiSparkle,
    readTime: '4 min',
    category: 'Apskaita',
    publishDate: '2025-10-15'
  },
  {
    slug: 'bolt-apskaita-dokumentai',
    title: 'Bolt apskaita: 3 dokumentai, kuriuos PRIVALOTE atsisiųsti kas mėnesį',
    excerpt: 'Kelionių CSV, komisinio SF ir mėnesinė suvestinė — kur rasti, kaip atsisiųsti ir kam naudoti.',
    icon: PiCar,
    readTime: '7 min',
    category: 'Apskaita',
    publishDate: '2025-10-22'
  },
  {
    slug: 'pavezejo-mokesciai-gpm-psd-vsd',
    title: 'Mokesčiai pavežėjui 2026: GPM, PSD, VSD ir PVM',
    excerpt: 'Dauguma pavežėjų moka 2-3x daugiau GPM nei turėtų. Sužinokite apie mokesčio kreditą.',
    icon: PiReceipt,
    readTime: '9 min',
    category: 'Mokesčiai',
    publishDate: '2025-11-05'
  },
  {
    slug: 'individualios-veiklos-islaidos-30-procentu-arba-faktines',
    title: '30% norma ar faktinės išlaidos 2026: sutaupykite iki 2527€/metus',
    excerpt: 'Pasirinkus neteisingai, galite prarasti šimtus eurų. Štai kaip nuspręsti.',
    icon: PiPercent,
    readTime: '8 min',
    category: 'Išlaidos',
    publishDate: '2025-11-12'
  },
  {
    slug: '60-procentu-islaidos-strategija',
    title: '60% faktinės išlaidos: kaip uždirbti €45 000 ir mokėti tik 5% GPM',
    excerpt: 'Strategija, kurią naudoja tik 5% pavežėjų – ir kuri sutaupo jiems €2000+/metus.',
    icon: PiTrendUp,
    readTime: '9 min',
    category: 'Mokesčiai',
    publishDate: '2025-11-28'
  },
  {
    slug: 'mokesciu-kalendorius-kada-moketi-mokescius',
    title: 'Mokesčių kalendorius 2026: pavėluosite = prarasite',
    excerpt: 'Vienas pavėluotas mokėjimas = 10-50% bauda. Štai datos, kurių NEGALITE praleisti.',
    icon: PiCalendarCheck,
    readTime: '6 min',
    category: 'Mokesčiai',
    publishDate: '2025-12-10'
  },
  {
    slug: 'kuro-apskaita-3-metodai-islaidos',
    title: 'Kuro apskaita 2026: 3 metodai, kurie sutaupo šimtus eurų',
    excerpt: 'Vidutinis pavežėjas išleidžia €300-500/mėn. kurui. Tinkama kuro apskaita gali atgauti šimtus eurų.',
    icon: PiGasPump,
    readTime: '7 min',
    category: 'Išlaidos',
    publishDate: '2025-12-18'
  },
  {
    slug: 'atvirkstinis-pvm-pavezejams',
    title: 'Atvirkštinis PVM: mokestis, kurį dauguma pavežėjų pamiršta',
    excerpt: 'Kas mėnesį VMI siunčia baudas pavežėjams. Šis gidas padės to išvengti.',
    icon: PiCurrencyEur,
    readTime: '7 min',
    category: 'PVM',
    publishDate: '2026-01-08'
  },
  {
    slug: 'pvm-pakeitimai-pavezejams-2025',
    title: 'SVARBU: PVM pakeitimai nuo gegužės 1 d.',
    excerpt: 'Nauji PVM reikalavimai paslaugoms iš užsienio – ką pavežėjai PRIVALO žinoti.',
    icon: PiWarning,
    readTime: '9 min',
    category: 'PVM',
    publishDate: '2026-01-15'
  },
  {
    slug: 'fr0457-automobilio-deklaravimas-vmi',
    title: 'Kaip užpildyti FR0457 formą: žingsnis po žingsnio',
    excerpt: 'Išsamus gidas, kaip deklaruoti automobilį VMI sistemoje per 5 minutes.',
    icon: PiClipboardText,
    readTime: '7 min',
    category: 'VMI',
    publishDate: '2026-01-22'
  },
  {
    slug: 'kodel-moketi-buhalteriui-40-eur',
    title: 'Kodėl mokėti buhalteriui 40€ už Bolt deklaracijas yra pinigų deginimas',
    excerpt: 'Buhalteris daro copy-paste už 40€/mėn. Tu gali tai padaryti per 3 minutes su Finhudas.',
    icon: PiRobot,
    readTime: '6 min',
    category: 'Apskaita',
    publishDate: '2026-02-03'
  },
  {
    slug: 'dac7-atvirkstinis-pvm-kaip-isvengti-baudu',
    title: 'DAC7 ir Atvirkštinis PVM: Kaip VMI seka Bolt vairuotojus',
    excerpt: 'VMI jau žino kiek uždirbi. O tu — ar žinai kiek skolingas Atvirkštinio PVM?',
    icon: PiShieldWarning,
    readTime: '6 min',
    category: 'PVM',
    publishDate: '2026-02-12'
  },
  {
    slug: 'tikroji-darbo-per-parka-kaina',
    title: 'Tikroji darbo „per parką" kaina: kiek tūkstančių atiduodate?',
    excerpt: '816€/metus atiduodi parkui. Finhudas — 7€/mėn. Nustok mokėti baimės mokestį.',
    icon: PiLinkBreak,
    readTime: '6 min',
    category: 'Apskaita',
    publishDate: '2026-02-25'
  },
  {
    slug: 'nematomi-mokesciu-spastai-bolt-vairuotojams',
    title: 'Nematomi mokesčių spąstai: kodėl 80% naujų vairuotojų skolingi VMI',
    excerpt: 'Bolt mokėjimas ≠ pelnas. Tomas manė, kad uždirba 1 125€. Realybė — 537€.',
    icon: PiEyeSlash,
    readTime: '8 min',
    category: 'Mokesčiai',
    publishDate: '2026-03-05'
  },
  {
    slug: 'gpm-moketi-dalimis-mokestine-paskola',
    title: 'Negali sumokėti GPM? Kaip mokėti mokesčius dalimis per VMI',
    excerpt: 'VMI leidžia mokėti dalimis iki 24 mėnesių. Jei skola iki 6 000 € — jokių dokumentų nereikia.',
    icon: PiHandCoins,
    readTime: '6 min',
    category: 'Mokesčiai',
    publishDate: '2026-03-12'
  }
  // TODO: Missing articles for SEO content gaps:
  // - 'kaip-pradeti-individualia-veikla-pavezejui' — "Kaip pradėti individualią veiklą pavežėjui: žingsnis po žingsnio"
  //   Target: New drivers (Naujokas profile), huge search volume for IV registration guide
  // - 'kiek-uzdirba-bolt-vairuotojas' — "Kiek uždirba Bolt vairuotojas 2026: tikri skaičiai"
  //   Target: Top-funnel awareness, people considering becoming drivers
  // - 'bolt-vs-uber-lietuvoje' — "Bolt vs Uber Lietuvoje: komisiniai, pajamos ir apskaita"
  //   Target: Drivers comparing platforms, captures brand comparison searches
]

const BlogIndexPage = () => {
  usePageSetup('Finhudas blogas: apskaita, mokesčiai ir patarimai pavežėjams', {
    description: '15 straipsnių apie Bolt ir Uber vairuotojų mokesčius, apskaitą ir išlaidas. Sužinokite, kaip sutaupyti €500–2000 per metus su teisinga apskaita.',
  })

  return (
    <>
      <HeaderBack to="/" />
      <div className="min-h-full bg-white px-5 pb-8 flex flex-col">

        <MotionText
          as="h1"
          className="text-zinc-900 text-2xl font-medium mt-3 mb-4"
        >
          Kaip pavežėjai sutaupo €500-2000 per metus su teisinga apskaita
        </MotionText>

        <MotionText
          as="p"
          className="text-zinc-700 text-sm mb-2"
        >
          90% pavežėjų permoka mokesčius arba rizikuoja baudomis – nes nežino šių 15 dalykų.
        </MotionText>

        <MotionText
          as="p"
          className="text-zinc-700 text-sm mb-6"
        >
          <strong>Naujas?</strong> Pradėk nuo „Mokesčiai pavežėjui 2026". <strong>Jau dirbi?</strong> „30% norma ar faktinės išlaidos" gali sutaupyti €2527+/metus.
        </MotionText>

        <MotionDiv className="flex flex-col gap-4">
          {articles.map((article, index) => {
            const Icon = article.icon
            return (
              <Link
                key={article.slug}
                to={`/blog/${article.slug}`}
              >
                <motion.div
                  className="flex gap-4 p-4 border border-zinc-250 rounded-xl hover:border-zinc-300 transition-colors"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.05 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-zinc-100 rounded-lg flex items-center justify-center">
                    <Icon className="w-6 h-6 text-zinc-700" />
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs font-medium text-zinc-500">
                        {article.category}
                      </span>
                      <span className="text-xs text-zinc-300">•</span>
                      <span className="text-xs text-zinc-500">
                        {article.readTime}
                      </span>
                      <span className="text-xs text-zinc-300">•</span>
                      <span className="text-xs text-zinc-400">
                        {article.publishDate}
                      </span>
                    </div>

                    <h3 className="text-base font-medium text-zinc-900 mb-1 line-clamp-2">
                      {article.title}
                    </h3>

                    <p className="text-sm text-zinc-600 line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>

                  <PiArrowRight className="flex-shrink-0 w-5 h-5 text-zinc-300 self-center" />
                </motion.div>
              </Link>
            )
          })}
        </MotionDiv>

        <Link to="/tax-calculator">
          <motion.div
            className="flex gap-4 p-4 bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl mt-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            whileTap={{ scale: 0.98 }}
          >
            <div className="flex-shrink-0 w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
              <PiPercent className="w-6 h-6 text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base font-medium text-white mb-1">
                Mokesčių skaičiuoklė 2026
              </h3>
              <p className="text-sm text-blue-100">
                Sužinok per 30 sek. kiek sutaupytum su faktinėmis išlaidomis
              </p>
            </div>
            <PiArrowRight className="flex-shrink-0 w-5 h-5 text-white/60 self-center" />
          </motion.div>
        </Link>
      </div>
    </>
  )
}

export default BlogIndexPage
